var map = {
	"./Montserrat-Bold.ttf": 72816,
	"./Montserrat-Bold.woff": 44272,
	"./Montserrat-Bold.woff2": 90322,
	"./Montserrat-Regular.ttf": 17495,
	"./Montserrat-Regular.woff": 50533,
	"./Montserrat-Regular.woff2": 6141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51549;